export const isHashtag = (value) => {
  return value && value.charAt(0) === '#'
}
